const styles = theme => ({
  root: {
    [theme.breakpoints.up(960)]: {
      paddingTop: 0,
      paddingBottom: 0,
    },
  },

  title: {
    color: theme.color.thundora,
    fontSize: '16px',
    lineHeight: '19px',
    marginBottom: 24,

    [theme.breakpoints.down(600)]: {
      fontSize: '14px',
      padding: '0 24px',
    },
  },

  iframe: {
    border: 0,
    height: 'calc(100vh - 70px)',
    width: '100%',

    [theme.breakpoints.up(960)]: {
      height: '1200px',
    },
  },

  faqRemoveSpaces: {
    paddingLeft: '0px',
  },
});
export default styles;
